import React, { ReactNode, useMemo } from "react";
import { ErrorMessage, Field } from "formik";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import { SelectInputProps as MuiSelectInputProps } from "@mui/material/Select/SelectInput";
import FilterWrapper from "./FilterWrapper";


const SelectField: React.FC<SelectFieldProps> = (props) => {
    return (
        <Field
            { ...props }
            name={ props.name }
            as={ SelectInput }
            label={ props.label }
            required={ props.required }
            onValueChange={ props.onChange }
            multiple={ props.multiple }
            hintText={
                <FormHelperText error>
                    <ErrorMessage name={ props.name }/>
                </FormHelperText>
            }
        />
    );
};

export const SelectInput: React.FC<SelectInputProps> = props => {
    const id: string = useMemo(() => String(Math.random()), [])

    return (
        <FormControl fullWidth size={ props.size }>
            <InputLabel id={ id } required={ props.required }>{ props.label }</InputLabel>
            <Select
                { ...props }
                labelId={ id }
                name={ props.name }
                onChange={ (event, child) => {
                    props.onChange && props.onChange(event, child);
                    props.onValueChange && props.onValueChange(event.target.value as string)
                } }
                onBlur={ props.onBlur }
                value={ props.value }
                multiple={ props.multiple }
            >
                { props.options.map(item => (
                    <MenuItem key={ item.value } value={ item.value }>
                        { item.label }
                    </MenuItem>
                )) }
            </Select>
            {
                props.helperText &&
                <FormHelperText>{ props.helperText }</FormHelperText>
            }
        </FormControl>
    );
};

export const SelectFilter: React.FC<SelectInputProps> = props => {
    return (
        <FilterWrapper used={ props.value !== undefined && props.value !== SELECT_EMPTY_VALUE }>
            <SelectInput { ...props } />
        </FilterWrapper>
    );
}

interface SelectFieldProps extends SelectInputProps {
    readonly name: string;
}

interface SelectInputProps extends Partial<MuiSelectInputProps> {
    readonly options: SelectOption[];
    readonly label?: string;
    readonly children?: ReactNode;
    readonly required?: boolean;
    readonly onValueChange?: (value: string) => void;
    readonly helperText?: string | ReactNode;
    readonly size?: 'small' | 'medium';
}

export interface SelectOption {
    label: string;
    value: string | number;
}


export default SelectField;

//@todo: do something legitimate with this
export const SELECT_EMPTY_VALUE = 0;